import { toast } from "react-hot-toast";

type StorageOptions = {
  notify?: boolean | string; // true = default msg, string = custom msg
};

export const storage = {
  set<T = string>(key: string, value: T, options?: StorageOptions) {
    const toStore = typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(key, toStore);

    if (options?.notify) {
      const message =
        typeof options.notify === "string"
          ? options.notify
          : `Value for "${key}" was saved`;
      toast.success(message);
    }
  },

  get<T = string>(key: string): T | null {
    const value = localStorage.getItem(key);
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch {
      return value as unknown as T;
    }
  },

  remove(key: string, options?: StorageOptions) {
    localStorage.removeItem(key);

    if (options?.notify) {
      const message =
        typeof options.notify === "string"
          ? options.notify
          : `Value for "${key}" was removed`;
      toast.success(message);
    }
  },

  isEqual(key: string, value: string | number): boolean {
    return localStorage.getItem(key) === value.toString();
  },
};
